import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import moment from 'moment';
import PageTitle from '@/components/v2/PageTitle.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import Paginator from '@/components/v2/Paginator.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ActionButton from '@/components/action_button/Index.vue';
import { successfulDestroy } from '@/helpers/mixins/LocalizationHelper';
import FetchAutomations from '@/plugins/graphql/queries/v2/affiliate/fetch-automations.gql';
import DeleteAutomation from '@/plugins/graphql/mutations/v2/your_store/delete-automation.gql';
import { AutomationModel } from '@/helpers/entities/models/AutomationModel';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let AffiliateAutomationTable = class AffiliateAutomationTable extends Mixins(FormMixin, ViewportSizeMixin, PaginatorMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.resetPagination = false;
        this.selectedAutomation = null;
        this.firstCursor = null;
        this.tableHeaders = [
            {
                text: 'NAME',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'POST COVERAGE',
                value: 'postUrl',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE CREATED',
                value: 'createdAt',
                align: 'left',
                sortable: false,
            },
            {
                text: 'VISITS',
                value: 'numberOfVisits',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ORDERS',
                value: 'numberOfOrders',
                align: 'center',
                sortable: false,
            },
            {
                text: 'CONVERSION',
                value: 'conversionRate',
                align: 'center',
                sortable: false,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    humanReadableDate(date) {
        return moment(date).format('ddd MMM DD YYYY h:mm A');
    }
    resetPaginationChecker() {
        this.resetPagination = false;
    }
    automationRouteSelect() {
        if (this.$route.params.key === 'affiliate-bundle') {
            return { name: 'edit-automation' };
        }
        return { name: 'ecommerce-edit-automation' };
    }
    editAutomation(automation_uuid) {
        const route = this.automationRouteSelect();
        this.automationAction('START EDIT');
        this.$router.push({ name: route.name, params: { uuid: automation_uuid } });
    }
    toggleConfirmation(uuid) {
        this.selectedAutomation = uuid;
        this.showConfirmationDialog();
    }
    async uponConfirm() {
        this.requestOnFlight();
        await this.$apollo
            .mutate({
            mutation: DeleteAutomation,
            variables: {
                input: {
                    automationUuid: this.selectedAutomation,
                },
            },
        })
            .then(() => {
            const msg = successfulDestroy('Comment Auto-Reply');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.$apollo.queries.automations.refetch();
            this.resetPagination = true;
            this.startCursor = null;
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], AffiliateAutomationTable.prototype, "appUuid", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], AffiliateAutomationTable.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], AffiliateAutomationTable.prototype, "hideConfirmationDialog", void 0);
AffiliateAutomationTable = __decorate([
    Component({
        components: {
            PageTitle,
            BaseSubtitle,
            ActionButton,
            Paginator,
            ConfirmationDialog,
        },
        apollo: {
            automations: {
                query: FetchAutomations,
                variables() {
                    return {
                        appUUID: this.appUuid,
                        after: this.startCursor,
                    };
                },
                fetchPolicy: 'network-only',
                update(data) {
                    const { pageInfo, totalCount, edges } = data.fetchAutomations;
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map((automation) => new AutomationModel(automation.node));
                },
            },
        },
    })
], AffiliateAutomationTable);
export default AffiliateAutomationTable;
